import { post, fetcher } from '../../../services/api';
import type { 
  OrganisedMeetingsFocusResponse, 
  AccessibleCalendarsResponse 
} from '../types/organisedMeetings';

interface CalendarsApiResponse {
  calendars: Array<{
    email: string;
    name: string;
  }>;
}

export const diaryManagementService = {
  getOrganisedMeetingsFocus: async (
    startDate: string,
    endDate: string
  ): Promise<OrganisedMeetingsFocusResponse> => {
    const response = await post<OrganisedMeetingsFocusResponse>(
      '/api/v1/diary-management/organised-meetings-focus',
      {
        start_date: startDate,
        end_date: endDate,
      }
    );
    return response;
  },

  getAccessibleCalendars: async (): Promise<AccessibleCalendarsResponse> => {
    const response = await fetcher<CalendarsApiResponse>(
      '/api/v1/diary-management/calendars'
    );
    
    return {
      calendars: response.calendars
        .map(cal => ({
          email: cal.email,
          name: cal.name,
        }))
    };
  },
};
